export default "__VITE_ASSET__Bd0qjaE5__"